module.exports = __webpack_public_path__ + "static/media/image_5.1ce54a8e.png";